import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';

function PendingSubsPageHeaderMobile({ handleReload }) {
    return (
        <div className="mb-2.5">
            <div className="input-with-filter flex justify-between items-center">
                {/* Input Field */}
                <div>Pending Subscription</div>
                {/* Action Button */}
                <div className="button-list flex items-center gap-[5px]">
                    <ReloadButton
                        className="!size-[35px] focus:outline-none"
                        onClick={handleReload}
                    />
                    {/* Customer add */}
                </div>
            </div>
        </div>
    );
}

export default PendingSubsPageHeaderMobile;
